import React from "react";
import "./footer.css";
import { FiTwitter, FiGithub, FiLinkedin, FiInstagram } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title" style={{ marginBottom: 3 }}>
          faizmdf
        </h1>
        <h1 className="footer__title" style={{ fontSize: 12 }}>
          powered by CyphrSylph ©2024
        </h1>

        <div className="footer__social">
          <a
            href="https://twitter.com/faizmdf"
            className="home__social-icon"
            target="_blank"
          >
            <FiTwitter />
          </a>
          <a
            href="https://www.github.com/faizfiaz"
            className="home__social-icon"
            target="_blank"
          >
            <FiGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/faizmdf/"
            className="home__social-icon"
            target="_blank"
          >
            <FiLinkedin />
          </a>
          <a
            href="https://www.instagram.com/faiz.mdf/"
            className="home__social-icon"
            target="_blank"
          >
            <FiInstagram />
          </a>
          <a
            href="https://link.tipnet.studio/pJWfibdMmRk"
            className="home__social-icon"
            target="_blank"
          >
            <FiInstagram />
          </a>
        </div>
        <span className="footer__copy"></span>
      </div>
    </footer>
  );
};

export default Footer;
